export default __webpack_public_path__ + "static/media/history.cb54c4e1.jpg";